import { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import PartnerSection from "../../components/PartnerSection";
import BrideGrooms from "../../components/BrideGrooms";

interface BrideGroomsPageProps {}

const BrideGroomsPage: React.FC<BrideGroomsPageProps> = () => {
  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle
        pageTitle="Bridesmaids & Groomsmen"
        pagesub="Bridesmaids & Groomsmen"
      />
      <BrideGrooms brClass="style-2" />
      <PartnerSection pClass="pb-120 pt-0" />
      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

export default BrideGroomsPage;
